import { Map } from 'immutable';
import { get, post, put, httpDelete } from './rest-api-calls';
import { handleError } from '../err';

function httpThunk(restCall, url, args, actions, additionalActionData = {}) {
  return (dispatch) => {
    dispatch({
      ...additionalActionData,
      type: actions.begin
    });
    return restCall(url, args)
      .then(data => {
        dispatch({
          ...additionalActionData,
          type: actions.success,
          data
        });
        return data;
      })
      .catch(err => {
        var formattedError = handleError(err);
        dispatch({
          ...additionalActionData,
          type: actions.failure,
          err: formattedError
        });
        throw formattedError;
      });
  }
}

export function getThunk(url, queryParams, actions, additionalActionData = {}) {
  return httpThunk(get, url, queryParams, actions, additionalActionData);
}

export function postThunk(url, data, actions, additionalActionData = {}) {
  return httpThunk(post, url, data, actions, additionalActionData);
}

export function putThunk(url, data, actions, additionalActionData = {}) {
  return httpThunk(put, url, data, actions, additionalActionData);
}

export function deleteThunk(url, actions, additionalActionData = {}) {
  return httpThunk(httpDelete, url, null, actions, additionalActionData);
}

/**
 * This function is used to determine if a certain action should be dispatched, or not.
 * It determines this based on the current state that is present at the given path.
 * If the data has not started to load yet, or if the existing data has been
 * invalidated by some other process then the action will be dispatched, otherwise the existing data is returned
 * Note: it is expected that this will be called whenever the state changes, because the data might need to be reloaded if the data was invalidated
 * (Example: when paging data changes, and a new page of the paged list needs to be loaded)
 * @param {array} path the path in the state that corresponds to the ApiCallState in question (includes which reducer the data belongs to)
 * @param {object} action the action that should be dispatched if the check passes
 */
export function shouldExecute(path, action) {
  return (dispatch, getState) => {
    const state = new Map(getState());
    const apiCallState = state.getIn(path);
    const { isFetching, isValid, data } = apiCallState || {};

    if(!apiCallState || !(isFetching || isValid)) {
      return dispatch(action);
    }
    else {
      return Promise.resolve(data);
    }
  }
}
